<template>
<w-settings-summary ref="settingsSummary" :menu="menu" @change="onChangeMenu">
  <component slot="activeView" :is="activeView" :title="activeMenu.name"></component>
</w-settings-summary>
</template>

<script>
import findIndex from 'lodash/findIndex';
import isEmpty from 'lodash/isEmpty';
import summaryApi from '@/api/settings/settings-summary';
import { getValueAfterCheckEmpty } from '@/utils/string';
import WSettingsSummary from '@/components/template/SettingsSummary';
import WVirtualService from './VirtualService';
import WProvisioning from './Provisioning';
import WMetering from './Metering';

export default {
  name: 'WVirtualSettings',
  components: {
    WSettingsSummary,
    WVirtualService,
    WProvisioning,
    WMetering,
  },
  data() {
    return {
      activeMenu: {},
      activeView: null,
      menu: [
        {
          id: 'virtualService',
          name: '가상화 서비스',
          desc: ['서버, 스토리지, 데스크탑, 네트워크 가상화 서비스에 대해 OS 이미지 목록과 H/W 사양을 설정 합니다.'],
          data: null,
          orderbyIndex: 1,
        },
        {
          id: 'provisioning',
          name: '프로비저닝',
          desc: ['요청관리를 통해 가상서비스를 할당받기 위한 프로비저닝 정보를 설정 합니다.'],
          data: null,
          orderbyIndex: 2,
        },
        {
          id: 'metering',
          name: '미터링',
          desc: ['사용량 기반 IT 서비스 모델에서 가상화 서비스에 대한 과금을 위해 각 자원 별 단가를 설정 합니다.'],
          data: null,
          orderbyIndex: 3,
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    onChangeMenu(activeView, activeMenu) {
      this.activeView = activeView;
      this.activeMenu = activeMenu;
    },
    clearActiveView() {
      this.$refs.settingsSummary.clearActiveView();
      this.loadData();
    },
    loadData() {
      // summaryApi.getDatabaseSettingsSummaryCount().then((response) => {
      //   const result = response.data;
      //   if (result.success === true && !isEmpty(result.data)) {
      //     const data = result.data;
      //     const savedQuerySettingsData = [`현재 등록된 사용자 쿼리문은 <em>${getValueAfterCheckEmpty(data.savedQueryCount)}개</em> 입니다.`];
      //     const savedQuerySettingsIndex = findIndex(this.menu, (item) => item.id === 'savedQuery');
      //     this.menu[savedQuerySettingsIndex].data = savedQuerySettingsData;
      //   }
      // });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/index.vue